import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { isDigitsOnlyPattern, isMobilePePattern, normalizeMobilePePrefix } from "./customfields-input.util";

@Component({
    selector: "app-customfields-input",
    templateUrl: "./customfields-input.component.html",
    styleUrls: ["./customfields-input.component.scss"],
    standalone: false
})
export class CustomfieldsInputComponent implements OnInit {
  @Input() parentForm: FormGroup;
  @Input() type = "text";
  @Input() pattern = null;
  @Input() maxlength: number | null = null;
  @Input() format: boolean | null | string | number;
  @Input() required = false;
  @Input() fcName;
  @Input() validationMessage = "";
  @Input() disabled = false;
  @Input() readonly = false;

  @Output() inputChange: EventEmitter<string> = new EventEmitter<string>();

  get digitsOnly(): boolean {
    return isDigitsOnlyPattern(this.pattern);
  }

  get mobilePePrefix(): boolean {
    return isMobilePePattern(this.pattern);
  }

  // maxlength efectivo para el atributo HTML. En celular PE devolvemos null: si el
  // navegador aplica maxlength=9 y el usuario pega "+51987654321", corta por la izquierda
  // ANTES de disparar (input), y onValueInput/normalizeMobilePePrefix nunca ven el string
  // completo. Sin maxlength HTML reciben el valor entero y el util recorta a los ultimos 9.
  get effectiveMaxlength(): number | null {
    if (this.mobilePePrefix) return null;
    return this.maxlength || null;
  }

  constructor() {}

  ngOnInit() {
    this.validationMessage = this.type === 'email' ? 'Ingrese un Email valido':this.validationMessage;
    // Asegurar que format sea boolean o null
    if (this.format !== null && this.format !== undefined) {
      this.format = this.format === true || String(this.format) === 'true' || Number(this.format) === 1 || String(this.format) === '1';
    }
    // No se normaliza el valor en carga: reescribir aqui corromperia datos legados que
    // no calzan con ^9[0-9]{8}$ (p.ej. "+51987654321" -> "951987654"). El prefijo se
    // aplica solo ante input del usuario (onValueInput); un valor guardado no conforme lo
    // marca invalido el Validators.pattern, sin mutarlo en silencio.
  }

  onValueInput(event: Event) {
    const control = this.parentForm?.controls?.[this.fcName];
    if (!control) return;
    const input = event.target as HTMLInputElement;
    let next = input?.value ?? control.value ?? '';
    if (this.mobilePePrefix) {
      // normalizeMobilePePrefix ya recorto correctamente (ultimos N); no re-aplicar el
      // cap generico, que cortaria por la izquierda.
      next = normalizeMobilePePrefix(next, this.maxlength);
    } else {
      if (this.digitsOnly) {
        next = String(next).replace(/\D/g, '');
      }
      if (this.maxlength && String(next).length > this.maxlength) {
        next = String(next).slice(0, this.maxlength);
      }
    }
    if (next !== control.value) {
      control.setValue(next);
      if (input && input.value !== next) {
        input.value = next;
      }
    }
    this.inputChange.emit(control.value);
  }
}
